<template>
    <portal to="DialogsContainer">
        <transition name="modal">
            <div :class="useModalDialogsV2 ? 'modal-maskV2' : 'modal-mask'">
                <div class="modal-wrapper">
                    <div :class="['modal-container', containerStyle, useModalDialogsV2 ? 'modal-containerV2' : '']">
                        <div :class="useModalDialogsV2 ? 'modal-headerV2' : 'modal-header'">
                            <div :style="useModalDialogsV2 ? {width: '100%'} : {paddingTop: '10px', paddingRight: '12px', paddingBottom: '6px', paddingLeft: '12px', width: '100%', height: '41px'}">
                                <img src="../../../public/icons/workflow/close.svg" class="theme-svg" id="close" @click="$emit('close')" />
                            </div>
                        </div>

                        <div :class="useModalDialogsV2 ? 'modal-bodyV2' : 'modal-body'" :style="useModalDialogsV2 ? {textAlign: 'left'} : {textAlign: 'center'}">
                            <div v-if="!useModalDialogsV2" class="center">
                                <img :src="IconUrl" />
                            </div>
                            <div :class="useModalDialogsV2 ? 'left' : 'center'" style="font-weight:bold; font-size:22px;">
                                {{ title }}
                            </div>
                            <div v-if="!IsHtml" :class="useModalDialogsV2 ? 'left' : 'center'" style="margin-top:40px;">
                                {{ message }}
                            </div>
                            <div v-else class="dialoghtml">
                                <div v-html="$sanitize(message)" style="padding:12px; overflow-y: auto; text-align: left;"></div>
                            </div>
                        </div>

                        <div :class="useModalDialogsV2 ? 'modal-footerV2' : 'modal-footer'">
                            <slot name="footer">
                                <CommonButton
                                    :type="ButtonType.Primary"
                                    :text="Localizer.Localize('Ok_PascalCase')"
                                    @click="$emit('close')"/>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </portal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import CommonButton from "@/components/helpers/CommonButton.vue";
import { Portal, PortalTarget } from 'portal-vue';
import { Localizer } from "@/api/Localizer";
import { resolveWithBase } from '@/utils/pathUtils';
import { ButtonType } from "@/components/helpers/HelpersInterface";

    @Component({ components: { Portal, CommonButton } })
    export default class Dialog extends Vue {
        @Prop() private size!: string;
        @Prop() private icon!: string;
        @Prop() private title!: string;
        @Prop() private message!: string;
        @Prop() private ishtml!: boolean;
        private Localizer = new Localizer(this.$store);
        ButtonType = ButtonType;

        get useModalDialogsV2(): boolean { return this.$store.state.security.ModalDialogsFeatureFlagValue; }

        get containerStyle() {
            return this.size;
        }

        get IconUrl() {
            if (this.icon == null) {
                return resolveWithBase('/icons/dialog/info.svg');
            }
            return resolveWithBase(`/icons/dialog/${this.icon}.svg`);
        }

        get IsHtml() {
            return this.ishtml ?? false;
        }

        mounted() {

        }
}
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-maskV2 {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #242d48b3;
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 50%;
        margin: 0px auto;
        margin-top: 50px;
        padding: 10px 12px 0px 12px;
        transition: all 0.3s ease;
        background-color: var(--background-primary);
        box-sizing: border-box;
    }

    .modal-containerV2 {
        width: 50%;
        margin: 0px auto;
        padding: 0;
        transition: all 0.3s ease;
        box-sizing: border-box;
        background-color: var(--background-primary);
        border-radius: 4px;
    }

    .modal-header {
        margin: -10px -12px 0px -12px;
        border-bottom-width: 0px;
    }

    .modal-headerV2 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        border-bottom: none;
        font-size: 18px;
        line-height: 21px;
        font-weight: 600;
    }

    .modal-container.sm {
        width: 800px;
        max-width: 35%;
    }

    .modal-container.md {
        width: 800px;
        max-width: 40%;
    }

    .modal-container.lg {
        width: 800px;
        max-width: 50%;
    }

    .modal-body {
        margin: 12px 40px 0px 40px;
    }

    .modal-bodyV2 {
        margin: 0;
        padding: 16px;
        text-align: left;
    }

    .modal-footer {
        border-top-width: 0px;
    }

    .modal-footerV2 {
        display: flex;
        justify-content: end;
        margin: 0;
        padding: 16px;
        border-top: 1px solid var(--anaplan-border);
        gap: 16px;
    }

    .modal-enter-from {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

        .modal-enter-from .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }

    #close {
        float: right;
        cursor: pointer;
    }

    .left {
        text-align: left;
        margin: 0;
    }

    .center {
        margin: 0 auto;
    }
</style>
<style>
    .dialoghtml {
        max-height: calc(100vh - 385px);
        overflow-y: auto;
        padding-top: 24px;
    }

    .dialoghtml .bordered {
        border: 0 !important;
    }
</style>
